import { render, staticRenderFns } from "./MonthlyEISSocso.vue?vue&type=template&id=5aee2368&scoped=true"
import script from "./MonthlyEISSocso.vue?vue&type=script&lang=js"
export * from "./MonthlyEISSocso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aee2368",
  null
  
)

export default component.exports